import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconPassed = memo(({ color = '#59C891', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M21 7L9 19l-5.5-5.5 1.41-1.41L9 16.17 19.59 5.59z"
      />
    </Svg>
  );
});
